import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-060843d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "dashboard" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = {
  class: "text",
  style: {"font-weight":"bold"}
}
const _hoisted_5 = { class: "cards" }
const _hoisted_6 = { class: "image" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "image" }
const _hoisted_9 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_couthing_alt_svg = _resolveComponent("app-couthing-alt-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_instruction_svg = _resolveComponent("app-instruction-svg")!
  const _component_app_preferences_svg = _resolveComponent("app-preferences-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t("home.welcome", [_ctx.appTitle])), 1),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'BreathingExercise-Start' },
        class: "card"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_app_couthing_alt_svg)
          ]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("home.start_exercise")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("section", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'BreathingExerciseInstructions' },
          class: "card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_app_instruction_svg)
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("home.exercise_instructions")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'BreathingExercisePreferences' },
          class: "card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_app_preferences_svg)
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("home.exercise_preferences")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}